export const sanitizePhoneNumber = (phone: string) => phone && "+" + phone.replace(/\D/g, "");

const _autoPlural = (word?: string) => { /* todo: improve it to add other languages support */
	if (!word) return null;
	if (word.endsWith("y") && !/[aeiou]y$/i.test(word)) return word.slice(0, -1) + "ies";
	else if (/(s|x|z|ch|sh)$/.test(word)) return word + "es";
	else if (word.endsWith("f")) return word.slice(0, -1) + "ves";
	else if (word.endsWith("fe")) return word.slice(0, -2) + "ves";
	else return word + "s";
};

export const pluralize = (value: number, text: string) => {
	const words = text.trim().split(/\s+/);
	if (words.length === 0) return `${value}`;

	const lastWord = words.pop();
	const pluralWord = value === 1 ? lastWord : _autoPlural(lastWord);
	return `${value} ${[...words, pluralWord].join(" ")}`;
};

export const toCamelCase = (word?: string) => word?.replace(/[-_ ]+(\w)/g, (_, c) => c ? c.toUpperCase() : "")
	.replace(/^\w/, (c) => c.toLowerCase());

export const toKebabCase = (word?: string) => word?.replace(/([A-Z])/g, "-$1") // Add a hyphen before each uppercase letter
	.toLowerCase() // Convert the entire string to lowercase
	.replace(/^-/, ""); // Remove any leading hyphen if it exists (for the first word)

export const truncate = (word: string | null, max: number) => word && word.length > max ? word.slice(0, max - 1) + "…" : word;

export const trimTrailingSlash = (text: string) => {
	if (text.endsWith("/")) return text.slice(0, -1);
	else return text;
};

export const pascal = {
	addSpaces: (word: string) => word.replace(/([A-Z])/g, " $1").trim()
};

export default {
	pascal,
	pluralize,
	sanitizePhoneNumber,
	toCamelCase,
	toKebabCase,
	trimTrailingSlash,
	truncate
};